import React from 'react'
import { Container } from '../components'
import ConfirmReservation from '../components/Reservation/ConfirmReservations'

function ConfirmReservationPage() {
  return (
    <Container>
        <ConfirmReservation />
    </Container>
  )
}

export default ConfirmReservationPage